import React, { useEffect, useState } from "react";
import { ListRedes } from "../beneficios/utils";
import { Col, Row } from "reactstrap";
import descargar from "../assets/img/icon/icon_descargar.svg";
import detalles from "../assets/img/icon/detalles.png";

export const BeneficioCardGrande = ({ beneficio, espere, print, open, windowWidth }) => {
    const [showIconScroll, setShowIconScroll] = useState(false);
    const [cardMaxHeight, setCardMaxHeight] = useState(325); // definido en el diseño

    useEffect(() => {
        if (windowWidth >= 991 && windowWidth <= 1367) {
            setCardMaxHeight(260); // definido en el diseño
        }
    }, [windowWidth, beneficio]);

    useEffect(() => {
        setTimeout(() => {
            const showIcon =
                document.getElementById("ben" + beneficio?.cdBeneficio + "contenido")?.clientHeight > cardMaxHeight;
            setShowIconScroll(showIcon);
        }, [500]);
    }, [cardMaxHeight, beneficio]);

    return (
        <div className={`mt-2 ${open ? "col-lg-9" : "col-md-9 mx-md-auto col-xl-4"}`}>
            <div
                id={"ben" + beneficio?.cdBeneficio}
                className={`borde--height ${!espere && "scrollable"}`}
                style={{ minHeight: `${beneficio?.red === ListRedes.find(l => l.letra === "S").id ? "" : ""}` }}
            >
                <div className={"col-lg-12 beneficios__seccion"}>
                    <span>
                        <span className={"d-none d-md-inline-block"}>{""}</span>
                        <b className={"ml-2"}>{beneficio.cdRedCob}</b>
                    </span>
                    <ButtonDescargar
                        className={"d-none d-md-block"}
                        beneficio={beneficio}
                        print={print}
                        espere={espere}
                    />
                </div>
                <div id={"ben" + beneficio?.cdBeneficio + "contenido"} className={`beneficios__contenido`}>
                    <Row>
                        <Col md={12}>
                            <Row className={"font-medium-title container m-0 py-3"}>
                                <div className={`col-12 text-primary text-justify mb-2 `}>{beneficio?.descripcion}</div>
                                <div className={`col-lg-4 text-primary `}>
                                    <span>{"Red: "}</span>
                                </div>
                                <div className={`col-lg-8 `}>{beneficio?.red}</div>
                                <div className={"col-lg-4 text-primary"}>
                                    <span>{"Especialidad: "}</span>
                                </div>
                                <div className={"col-lg-8"}>{beneficio?.especialidad}</div>
                                {beneficio?.red !== ListRedes.find(l => l.letra === "S").id ? (
                                    <>
                                        <div className={"col-lg-4 text-primary"}>
                                            <span className={""}>{"Proveedor: "}</span>
                                        </div>
                                        <div className={"col-lg-8"}>{beneficio?.nombreProveedor}</div>
                                        {beneficio?.red !== ListRedes.find(l => l.letra === "F").id ? (
                                            <>
                                                <div className={"col-lg-4 text-primary"}>
                                                    <span className={""}>{"Médico: "}</span>
                                                </div>
                                                <div className={"col-lg-8"}>{beneficio?.nombre}</div>
                                            </>
                                        ) : (
                                            <>
                                                <div className={"col-lg-4 text-primary"}>
                                                    <span className={""}>{"Punto de Venta: "}</span>
                                                </div>
                                                <div className={"col-lg-8"}>{beneficio?.puntoVenta}</div>
                                            </>
                                        )}
                                        <div className={"col-lg-4 text-primary"}>
                                            <span className={""}>{"Ciudad: "}</span>
                                        </div>
                                        <div className={"col-lg-8"}>{beneficio?.ciudad}</div>
                                        <div className={"col-lg-4 text-primary"}>
                                            <span className={""}>{"Dirección: "}</span>
                                        </div>
                                        <div className={"col-lg-8"}>{beneficio?.direccion}</div>
                                        <div className={"col-lg-4 text-primary"}>
                                            <span className={""}>{"Teléfono: "}</span>
                                        </div>
                                        <div className={"col-lg-8"}>{beneficio?.telefono}</div>
                                    </>
                                ) : (
                                    <>
                                        <div className={"col-lg-4 text-primary"}>
                                            <span className={""}>{"Protocolo: "}</span>
                                        </div>
                                        <div className={"col-lg-8"}>{beneficio?.protocolo}</div>
                                        <div className={"col-lg-4 text-primary"}>
                                            <span className={""}>{"Paquete: "}</span>
                                        </div>
                                        <div className={"col-lg-8"}>{beneficio?.paquete}</div>
                                    </>
                                )}

                                <div className="col-12 mt-2 text-right">
                                    <ButtonDescargar
                                        className={"d-block d-md-none"}
                                        beneficio={beneficio}
                                        print={print}
                                        espere={espere}
                                    />
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </div>
                {showIconScroll && !espere && (
                    <div className={"text-center text-primary pt-1 iconito-white"}>
                        <i className={"fas fa-angle-double-down fa-bounce"} />
                    </div>
                )}
            </div>
        </div>
    );
};

export const BeneficioCardPeque = ({ grupo, beneficio, espere, print, showCardPeque, setShowCardPeque, open }) => {
    const [showCardGrande, setShowCardGrande] = useState(false);

    return (
        <>
            <div className={`${open ? "col-lg-6" : "col-sm-6 col-lg-4 col-xl-3"} ${!showCardPeque && "d-none"}`}>
                <div className={"w-100 borde--height peque"}>
                    <div className={"col-lg-12 beneficios__seccion"}>{grupo || beneficio?.cdRedCob}</div>
                    <div className={"container"}>
                        <div className="row justify-content-center align-items-center">
                            <div className="col px-4 my-5">
                                <div className={"text-primary pb-1 font-medium"}>
                                    <h5>{"Proveedor:"}</h5>
                                </div>
                                <div className={"text-dark"}>
                                    <h5>{beneficio?.nombreProveedor}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"beneficios__footer"}>
                        <div className="d-flex justify-content-between mx-2 py-2">
                            <label
                                className={"c-pointer"}
                                onClick={() => {
                                    setShowCardGrande(!showCardGrande);
                                    setShowCardPeque(false);
                                }}
                            >
                                <img src={detalles} width={"16"} /> &nbsp;
                                <small>Ver Cartilla</small>
                            </label>
                            <ButtonDescargar
                                className={"d-block"}
                                className2={"text-small"}
                                beneficio={beneficio}
                                print={print}
                                espere={espere}
                                automatico={true}
                                setShowCardPeque={setShowCardPeque}
                                setShowCardGrande={setShowCardGrande}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const ButtonDescargar = ({ espere, print, beneficio, ...props }) => {
    const handlePrint = () => {
        if (props?.setShowCardGrande && props?.setShowCardGrande) {
            props?.setShowCardPeque(false);
            props?.setShowCardGrande(true);
        }
        print("ben" + beneficio.cdBeneficio, props?.automatico);
    };
    return (
        <div className={props?.className || ""}>
            {!espere && (
                <button className={"beneficios__btn " + props?.className2} onClick={handlePrint}>
                    {"Descargar"}
                    &nbsp;
                    <img src={descargar} width={"12"} />
                </button>
            )}
        </div>
    );
};
